'use client';

import { useEffect, useRef } from 'react';
import { useTranslation } from '@/context/LanguageContext';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default function ChatwootWidget() {
  const { locale } = useTranslation();
  const initialized = useRef(false);

  useEffect(() => {
    const BASE_URL = 'https://chat.klonkaffe.denkedelige.dk';
    const TOKEN = process.env.NEXT_PUBLIC_CHATWOOT_TOKEN;
    if (!TOKEN) return;

    const w = window as any;
    w.chatwootSettings = {
      hideMessageBubble: false,
      position: 'left',
      locale: locale,
      type: 'expanded_bubble',
      darkMode: 'auto',
    };

    if (initialized.current) return;
    initialized.current = true;

    const script = document.createElement('script');
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      w.chatwootSDK?.run({
        websiteToken: TOKEN,
        baseUrl: BASE_URL,
      });
    };
    document.head.appendChild(script);
  }, [locale]);

  useEffect(() => {
    const w = window as any;

    w.chatwootSettings = {
      ...w.chatwootSettings,
      locale: locale,
    };

    if (w.$chatwoot?.setLocale) {
      w.$chatwoot.setLocale(locale);
    }
  }, [locale]);

  return null;
}
